import sumoLogo from '../images/sumo_logo.png'
import { Button } from '../components/button'
import { useNavigate } from 'react-router-dom'
import { Input } from '../components/input'
import { useState, useEffect } from 'react'
import { AuthLayout } from '../components/auth-layout'
export default function LinkGoogleAccount() {
	const [formData, setFormData] = useState({ company_name: '', display_name: '', email: '', passwd: '' });
	const [errors, setErrors] = useState({});
	const [serverError, setServerError] = useState('');
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const validate = () => {
		const newErrors = {};		
		if (!formData.email) {
			newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
			newErrors.email = 'Please enter valid Email';
        }		
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
    };
	const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
        setServerError('');
    };
	const handleClick = () => {
		setLoading(true);
		setTimeout(() => {
			// After 5 seconds, navigate to new page
			navigate('/list-companies');
		}, 2000);
	};
	const handleSubmit = async (e) => {
		e.preventDefault(); // prevent page reload
		if (!validate()) return;
		setLoading(true);
		try {
			setLoading(true);
			console.log(loading);
			setTimeout(() => {
				// After 5 seconds, navigate to new page
				navigate('/list-companies');
			}, 2000);
			setLoading(false);
		} catch (err) {
			setLoading(false);
			setServerError('Server error. Please try again later.');
			console.error('Error:', err);
		}
		setLoading(false);
	};
	
	return (
<div class="m-25">
	<div class="max-w-[650px] w-full m-auto box-border border shadow-[1px_1px_2px_rgb(247_11_98/30%)] rounded-[4px] border-solid border-[#913a7399]">
		<div class="box-border w-[100px] mt-[10px] m-auto"><img src={sumoLogo} class="box-border align-middle w-full border-0" /></div>
		<form onSubmit={handleSubmit} id="contact_form" method="post" action="" class="box-border">
			<div class="box-border p-6" >
				<div class="box-border text-center" >
					<div class="box-border font-semibold not-italic text-[45px] pb-[2px]">Welcome to FeedSumo</div>
					<div class="box-border font-medium not-italic text-[22px] pb-[17px]">Let's get you started</div>
					<div class="box-border font-semibold not-italic text-[21px]">Now Let's link your Google account</div>
				</div>
				
				<div class="box-border overflow-auto not-italic mt-[25px] m-auto">
					<div class="box-border overflow-auto">
	            	    <label class="box-border font-semibold inline-block max-w-full relative min-h-px text-right leading-[36px] mb-[5px] pl-[15px] pr-[4px] text-red-500">Provide an valid Google Merchant Center email</label>
						<div class="box-border relative min-h-px px-[15px]">
							<Input type="text" name="email" id="email"  value={formData.email} onChange={handleChange} className={`${
								errors.email ? 'border-red-500 border-1 rounded-lg' : 'border-gray-500'}`}/>
							{errors.email ? <p className="text-red-500 text-sm mt-1">{errors.email}</p> : <p className="text-red-500 text-sm mt-1">&nbsp;</p>}
						</div>
					</div>
				</div>
			
				<div class="box-border text-center mt-[5px]">
					<div class="px-[25px] flex items-center justify-center">
						{!loading && (
						<Button color="amber" type="submit"  id="create_account" value="" 
						class="box-border leading-[inherit] relative text-[16px] text-center no-underline text-white bg-[#3074AD] cursor-pointer mx-[20px] my-[10px] px-[20px] py-[8px] rounded-[7px] border-[none]">Link Google Account</Button>
						)}
						{loading && (<div className="text-center w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>)}
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
);
}